import * as types from "./actionTypes";

export const browserWindowVisibilityChanged = visible => {
    return {
        type: types.BROWSER_WINDOW_VISIBILITY_CHANGED,
        visible
    };
};
  